const ShopTimeEntryDetailTable = () => {

    return [
        {
            Header: 'VP ID',
            accessor: 'erp_id',
        },
        {
            Header: 'Last Name',
            accessor: 'last_name',
        },
        {
            Header: 'First Name',
            accessor: 'first_name',
        },
        {
            Header: 'Date',
            accessor: 'date',
        },
        {
            Header: 'State',
            accessor: 'abbreviation',
        },
        {
            Header: 'Job #',
            accessor: 'job_number',
        },
        {
            Header: 'Hours',
            accessor: 'hours',
        },
        {
            Header: 'Reason',
            accessor: 'ec_name',
        },
        {
            Header: 'Per Diem',
            accessor: 'per_diem',
        },
        {
            Header: 'Equipment #',
            accessor: 'equipment_number',
        },
        {
            Header: 'Cost Code',
            accessor: 'cost_code_description',
        },
    ];
}

export default ShopTimeEntryDetailTable;
